const Views = self => ({
    get allContacts() {
        if (self.numberOfOnDemandContacts === 0) {
            return [];
        }
        return Array.from(self.onDemandContacts.values()).filter(contact => !contact.isRevealed);
    },
    get hasOnDemandContact() {
        return self.allContacts.length > 0;
    },
    get selectedContact() {
        return self.onDemandContacts.get(self.selectedContactId);
    },
    get numberOfEmailsDisplayed() {
        var _a;
        return (_a = self.allContacts) === null || _a === void 0 ? void 0 : _a.reduce((total, contact) => total + contact.totalEmailsCollected, 0);
    },
    get numberOfPhonesDisplayed() {
        var _a;
        return (_a = self.allContacts) === null || _a === void 0 ? void 0 : _a.reduce((total, contact) => total + contact.totalPhonesCollected, 0);
    },
    get hasNewOnDemandContacts() {
        return self.numberOfNewOnDemandContacts > 0;
    },
});
export default Views;
